<div class="modal-header">
    <h3 class="modal-title text-uppercase">Documents</h3>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <i class="fas fa-times"></i>
    </button>
</div>
<div class="modal-body" detect-scroll (onScroll)="loadData($event)" [bottomOffset]="200" [topOffset]="200" *ngIf="circle">
    <app-medias [circle]="circle" [scrollEvent]="scrollEvent" (onNavigationStart)="bsModalRef.hide()" [container]="modal-medias"></app-medias>
</div>
